<template>
    <div class="tools-tab tools-tab-conflicts">
        <span class="message">{{ $t('conflict.message') }}</span>
        <ul>
            <li v-for="conflict in conflicts">
                {{ $t('conflict.' + conflict) }}
                <a href="#" @click.prevent="resolve(conflict)" v-if="isResolvable(conflict)">{{ $t('common.button.okay') }}</a>
                <a href="#" @click.prevent="resolve(conflict)" v-if="conflict == 'AVAILABILITY'">{{ $t('page.roster.undroppable.confirm') }}</a>
            </li>
        </ul>
    </div>
</template>

<script>
import shared from '../../../pages/planning/shared';

export default
{
    name: 'Conflict',

    props: ['item'],

    data() {
        return {
            shared: shared.state,
        }
    },

    computed:
    {
        conflicts()
        {
            return this.item.conflicts;
        },
    },

    methods:
    {
        resolve(conflict)
        {
            this.$http.delete('/api/items/' + this.item.id + '/conflicts',
            {
                data: {
                    conflict: conflict
                }
            }).then(response =>
            {
                this.$delete(this.item.conflicts, this.conflicts.indexOf(conflict));

                if ( ! this.conflicts.length)
                {
                    this.$set(this.item, 'conflicts', null);
                    this.$tools.close();
                }
            }).catch(error =>
            {
                if (error.response.data.message == 'NOT_AVAILABLE')
                {
                    let user = shared.getUser(this.item.user);

                    // user is not available, disallow scheduling!
                    this.$modal.show(this.$t('page.roster.add.error.headline'), user.name + ' ' + this.$t('page.roster.add.error.ERR_UNAVAILABLE_DENY'));
                }
            });
        },

        isResolvable(conflict)
        {
            return ['ERR_HOURS', 'ERR_CONFIRMED', 'ERR_OVERLAP_REST', 'ERR_OPEN_CHECKIN'].indexOf(conflict) != -1;
        },

        hasConflict(conflict)
        {
            if ( ! this.conflicts) return false;

            return this.conflicts.indexOf(conflict) != -1;
        }
    }
}
</script>



// WEBPACK FOOTER //
// Conflicts.vue?16995688